import { formatDate } from '@/helpers/dates'

export default {
  methods: {
    formatDate(date) {
      return formatDate(date)
    },
  }
}
